import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';
import {AccessibilityService, HotkeyMark, HotkeyType} from '../services/accessibility.service';
import {FocusUtil} from '../utils/focus.util';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[a11yHotkeyConfirm]',
    standalone: false
})
export class HotkeyConfirmDirective implements AfterViewInit {
    private accessibilityService = inject(AccessibilityService);
    private elementRef = inject(ElementRef);


    // Confirm hotkey - Defaults to CTRL-ENTER
    @Output() hotkeyConfirm = new EventEmitter<string>();

    ngAfterViewInit() {
        setTimeout(() => {
            FocusUtil.applyHotkeyMarker(this.elementRef.nativeElement, HotkeyMark.hotkeyConfirm);
        }, 500); // TODO AC-109
    }

    @HostListener('keydown', ['$event']) onConfirm($event){
        if (this.accessibilityService.checkHotkey($event, HotkeyType.CONFIRM)) {
            $event.preventDefault();
            this.hotkeyConfirm.emit();
        }
    }
}
